var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24.2,11c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3v13.4c0,0.2-0.1,0.5-0.3,0.6c-2.9,1.4-4.1,5-2.7,7.9 s5,4.1,7.9,2.7c2.9-1.4,4.1-5,2.7-7.9c-0.6-1.2-1.5-2.1-2.7-2.7c-0.2-0.1-0.3-0.4-0.3-0.6L24.2,11z M25.9,30.3 c0,2.2-1.8,3.9-3.9,3.9s-3.9-1.8-3.9-3.9c0-1.9,1.4-3.5,3.3-3.8v-3.6c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0c0.3,0,0.6,0.3,0.6,0.6l0,0 v3.6C24.5,26.7,25.9,28.4,25.9,30.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.4,11c0-1.9-1.5-3.4-3.4-3.4c0,0,0,0,0,0c-1.9,0-3.4,1.5-3.5,3.4v13.1c-3.4,1.9-4.6,6.3-2.7,9.7 c1.9,3.4,6.3,4.6,9.7,2.7c2.2-1.3,3.6-3.6,3.6-6.2c0-2.6-1.4-5-3.7-6.2V11z M24.5,25c2.9,1.4,4.1,5,2.7,7.9s-5,4.1-7.9,2.7 c-2.9-1.4-4.1-5-2.7-7.9c0.6-1.2,1.5-2.1,2.7-2.7c0.2-0.1,0.3-0.4,0.3-0.6V11c0-1.3,1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3v13.4 C24.2,24.6,24.3,24.9,24.5,25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M22.5,22.8c0-0.3-0.3-0.6-0.6-0.6c0,0,0,0,0,0c-0.3,0-0.6,0.3-0.6,0.6l0,0v3.6c-2.1,0.3-3.6,2.3-3.3,4.5 s2.3,3.6,4.5,3.3s3.6-2.3,3.3-4.5c-0.3-1.7-1.6-3-3.3-3.3V22.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.5,9.7H27c-0.3,0-0.6,0.3-0.6,0.6l0,0c0,0.3,0.3,0.6,0.6,0.6l0,0h2.6c0.3,0,0.6-0.3,0.6-0.6l0,0 C30.2,10,29.9,9.7,29.5,9.7L29.5,9.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.4,12.6H27c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0c0,0.3,0.3,0.6,0.6,0.6l0,0h1.4c0.3,0,0.6-0.3,0.6-0.6 c0,0,0,0,0,0C29,12.9,28.7,12.6,28.4,12.6L28.4,12.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.5,15.4H27c-0.3,0-0.6,0.3-0.6,0.6l0,0c0,0.3,0.3,0.6,0.6,0.6h0h2.6c0.3,0,0.6-0.3,0.6-0.6v0 C30.2,15.7,29.9,15.4,29.5,15.4C29.6,15.4,29.6,15.4,29.5,15.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27,19.5h1.4c0.3,0,0.6-0.3,0.6-0.6v0c0-0.3-0.3-0.6-0.6-0.6l0,0H27c-0.3,0-0.6,0.3-0.6,0.6v0 C26.4,19.2,26.6,19.5,27,19.5L27,19.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M29.5,21.1H27c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h2.6c0.3,0,0.6-0.3,0.6-0.6 C30.1,21.4,29.9,21.1,29.5,21.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCold);
export default __webpack_public_path__ + "static/media/cold.44859d29e87ec803a6e3ef1ff8af4897.svg";
export { ForwardRef as ReactComponent };